import React , { useContext, useEffect, useState } from "react";
import { Tooltip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";

const EditIcon = () => {
  const [isShown, setIsShown] = React.useState(false);
  const [isHovered , setIsHovered] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const { t } = useTranslation();
    return (
        <>
            <Tooltip title={t('COMMON005')}>
                      <Box
                        className={darkMode ? 'iconButton_dark' : 'iconButton'}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}>
                      {isHovered ?
                        (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20.069" height="20" viewBox="0 0 20.069 20">
                            <path id="Path_23439" data-name="Path 23439" d="M-14047.071,1523.3h-.113a1.088,1.088,0,0,1-.766-.316,1.064,1.064,0,0,1-.312-.866l.547-5.332a2.337,2.337,0,0,1,.678-1.429l11.5-11.5a2.383,2.383,0,0,1,1.518-.554,2.354,2.354,0,0,1,1.617.64l3.508,3.507a2.26,2.26,0,0,1,.084,3.187l-11.5,11.508a2.357,2.357,0,0,1-1.429.672Zm13.02-17.981h0l-2.758,2.831,3.691,3.7,2.834-2.763-3.768-3.764Z" transform="translate(14048.269 -1503.299)" fill={darkMode ? '#fff' : '#474a4e'}/>
                          </svg>
                        ) :
                        (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20.069" height="20" viewBox="0 0 20.069 20">
                                <path id="Path_23439" data-name="Path 23439" d="M-14047.071,1523.3h-.113a1.088,1.088,0,0,1-.766-.316,1.064,1.064,0,0,1-.312-.866l.547-5.332a2.337,2.337,0,0,1,.678-1.429l11.5-11.5a2.383,2.383,0,0,1,1.518-.554,2.354,2.354,0,0,1,1.617.64l3.508,3.507a2.26,2.26,0,0,1,.084,3.187l-11.5,11.508a2.357,2.357,0,0,1-1.429.672Zm8.842-13.735h0l-7.4,7.32-.376,4.134,4.134-.387,7.369-7.343-3.725-3.723Zm4.178-4.246h0l-2.758,2.831,3.691,3.7,2.834-2.763-3.768-3.764Z" transform="translate(14048.269 -1503.299)" fill={darkMode ? '#fff' : '#474a4e'} opacity="0.8" />
                            </svg>
                        )
                    }
                </Box>
                 {/* <Box
                        onMouseEnter={() => setIsShown(true)}
                        onMouseLeave={() => setIsShown(false)}
                      >
                    {isShown ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 18 18">
                            <path id="Edit" d="M3,18.021V13.776a1,1,0,0,1,.29-.711l2.353-2.343h0l7.009-7.009h0L14.464,1.9a3,3,0,0,1,4.245,0l1.412,1.412a3,3,0,0,1,0,4.245L9.008,18.732a1,1,0,0,1-.711.29H4A1,1,0,0,1,3,18.021ZM7.786,11.4l2.834,2.834L16.207,8.65,13.373,5.816Zm8.13-8.13L14.795,4.394l2.834,2.834L18.75,6.106a1,1,0,0,0,0-1.412L17.328,3.273A1,1,0,0,0,15.916,3.273ZM5,17.02H7.836L9.2,15.658,6.364,12.825,5,14.187Z" transform="translate(-3 -1.023)" fill="#6b6e71" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 18 18">
                            <path id="Edit" d="M3,18.021V13.776a1,1,0,0,1,.29-.711l2.353-2.343h0l7.009-7.009h0L14.464,1.9a3,3,0,0,1,4.245,0l1.412,1.412a3,3,0,0,1,0,4.245L9.008,18.732a1,1,0,0,1-.711.29H4A1,1,0,0,1,3,18.021ZM7.786,11.4l2.834,2.834L16.207,8.65,13.373,5.816Zm8.13-8.13L14.795,4.394l2.834,2.834L18.75,6.106a1,1,0,0,0,0-1.412L17.328,3.273A1,1,0,0,0,15.916,3.273ZM5,17.02H7.836L9.2,15.658,6.364,12.825,5,14.187Z" transform="translate(-3 -1.023)" fill="#6b6e71" />
                        </svg>
                    )}
                </Box> */}
            </Tooltip>
        </>
    );
};
export default EditIcon;
